import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { inject } from '@angular/core';
import { APP_ROUTES } from '../Constants/APP_ROUTES';
import { Roles } from '../Constants/ROLES';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const userRoles = authService.getRoles();
  const requiredRoles: Roles[] = route.data['role'] ?? [];

  if (userRoles.includes(Roles.Admin)) {
    return true;
  }

  const hasAccess =
    requiredRoles.length === 0 || userRoles.some((r) => requiredRoles.includes(r as Roles));

  if (hasAccess) return true;

  router.navigate([`${APP_ROUTES.HOME}`]).then(() => false);
  return false;
};
